import { render } from "./Navigation.vue?vue&type=template&id=82d2a588&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=82d2a588&lang=scss&scoped=true"

import exportComponent from "/Users/jorgecastanho/Documents/projects/Website-JCLda/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d2a588"]])

export default __exports__